import React from "react";
import { useDiaryContext } from "../../../../hooks/useDiaryContext";
import {
  floorPlanConfigOptions,
  updateFloorPlanConfig
} from "./ViewFloorPlanConfigController";
import { Switch } from "../../../ui/switch";

const ViewFloorPlanConfig = () => {
  const { floorPlanConfig, setDiaryContext } = useDiaryContext();

  return (
    <div className="space-y-4">
      {floorPlanConfigOptions.map((option) => (
        <div
          key={option.key}
          className="flex items-center justify-between gap-3"
        >
          <label className="text-sm font-medium text-foreground flex-1 min-w-0">
            {option.label}
          </label>
          <Switch
            checked={!!floorPlanConfig[option.key]}
            onCheckedChange={(checked) => {
              updateFloorPlanConfig({
                update: { [option.key]: checked },
                floorPlanConfig,
                setDiaryContext
              });
            }}
          />
        </div>
      ))}
    </div>
  );
};

export default ViewFloorPlanConfig;
